// Constantes & libellés pour le module Devis

export const QUOTE_STATUS_META = {
  brouillon: { label: "Brouillon", color: "bg-gray-100 text-gray-700 border-gray-200" },
  envoye: { label: "Envoyé", color: "bg-blue-100 text-blue-700 border-blue-200" },
  consulte: { label: "Consulté", color: "bg-sky-100 text-sky-700 border-sky-200" },
  accepte: { label: "Accepté", color: "bg-emerald-100 text-emerald-700 border-emerald-200" },
  refuse: { label: "Refusé", color: "bg-red-100 text-red-700 border-red-200" },
  expire: { label: "Expiré", color: "bg-orange-100 text-orange-700 border-orange-200" },
  converti_en_facture: { label: "Converti en facture", color: "bg-teal-100 text-teal-700 border-teal-200" },
};

export const QUOTE_STATUSES = Object.keys(QUOTE_STATUS_META);
